import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/cost-list';
import AggregateNumber from "../../aggregate/aggregate-number";
import AggregateCost from "./components/aggregate-cost";

export default class CostFieldProto extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.valueType = gd.const.fields.valueType.FLOAT;
    }

    getAggregateClass() {return AggregateNumber}
    getAggregateOptions() {return [
        gd.const.aggregate.type.SUM,
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.AVERAGE
    ]}
    getDefaultAggregateFunction() {return gd.const.aggregate.type.SUM}

    get ListComponent() {
        return ListComponent.bind(null, this.type);
    }

    get AggregateComponent() {return AggregateCost.bind(null, this.getAggregateOptions());}
}